import Tag from 'models/tag/Tag';

/**
 * Class representing a news tag.
 * @extends Tag
 */
export default class NewsTag extends Tag {}
